<template>
  <div class="container m-b-lg">
    <div class="columns">
      <div class="column content">
        <h3 v-text="$wording.submitted.title_1" />
        <h4>On {{ $store.state.properties.successDate }}</h4>
        <p v-html="$sprintf($wording.submitted.text_2, type, address)" />
        <p>
          <span
            v-if="leadFreeCount > 0"
            v-html="$sprintf($wording.submitted.text_3, 'lead free', leadFreeCount)"
          />
          <br>
          <span
            v-if="leadSafeCount > 0"
            v-html="$sprintf($wording.submitted.text_3, 'lead safe', leadSafeCount)"
          />
        </p>
        <p>
          <strong>Department of Public Health</strong><br>
          City of Philadelphia
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    address() {
      return this.$store.getters['properties/selectedPropertyAddress'];
    },
    details() {
      return this.$store.state.properties.eligibilityCheckDetails;
    },
    type() {
      if (this.details.propertyType === 'Residential') {
        return this.$wording.submitted.text_5;
      }
      return this.$wording.submitted.text_4;
    },
    inspections() {
      return this.$store.state.properties.inspections.data || [];
    },
    leadFreeCount() {
      return this.inspections.filter(insp => insp.inspectionType === 'LeadFree').length || 0;
    },
    leadSafeCount() {
      return this.inspections.length - this.leadFreeCount;
    },
  },
};
</script>

<style> 
@media print {
   .navbar-burger, .content a, footer, .phl-logo {
     display: none;
   }
}
</style>